<template>
  <div
    v-if="showNavigationShell"
    id="nav"
    class="bb-sticky-header"
    style="z-index: 3000"
  >
    <!-------------------->
    <!--      debug     -->
    <!-------------------->
    <!-- <div>
      <p style="color: white">
        [ isAuthenticated = {{ isAuthenticated }} ]--[ getCurrentView =
        {{ getCurrentView }} ]
      </p>
    </div> -->
    <!--------------------->
    <!--    race list    -->
    <!--------------------->
    <RaceNavbar v-if="showRaceNavbar" />
    <!-------------------------->
    <!--    character list    -->
    <!-------------------------->
    <CharacterNavbar v-if="showCharacterNavbar" />
    <!---------------------------------->
    <!--    dm combat campaign view   -->
    <!---------------------------------->
    <CombatNavbarComponent v-if="showCombatNavbar" />
    <!------------------------->
    <!--   campaigns list    -->
    <!------------------------->
    <NavbarComponent v-if="showCampaignNavbar" />
    <!---------------------->
  </div>
  <!---------------------->
  <!--    page heading  -->
  <!---------------------->
  <PageHeader v-if="showPageHeader" />
  <router-view />
</template>

<script>
import CombatNavbarComponent from '@/components/CombatNavbar.vue'
import CharacterNavbar from '@/components/CharacterNavbar.vue'
import PageHeader from '@/components/PageHeader.vue'
import NavbarComponent from '@/components/Navbar.vue'
import RaceNavbar from '@/components/RaceNavbar.vue'
import { mapGetters } from 'vuex'

const PUBLIC_AUTH_ROUTE_NAMES = [
  'loginView',
  'logoutView',
  'registerView',
  'resendEmailView',
  'forgottenPasswordView',
  'resetPasswordView',
]

export default {
  name: 'App',
  //------------
  // components
  //------------
  components: {
    CombatNavbarComponent,
    PageHeader,
    NavbarComponent,
    CharacterNavbar,
    RaceNavbar,
  },
  //------
  // data
  //------
  data() {
    return {
      errors: [],
    }
  },
  //-----------------
  // computed values
  //-----------------
  computed: {
    ...mapGetters('auth', {
      getCurrentView: 'getCurrentView',
      isAuthenticated: 'isAuthenticated',
    }),
    showRaceNavbar() {
      return (
        this.isAuthenticated &&
        (this.getCurrentView == 'races' ||
          this.getCurrentView == 'spells' ||
          this.getCurrentView == 'campaign_artefacts')
      )
    },
    showCharacterNavbar() {
      return this.isAuthenticated && this.getCurrentView == 'characters'
    },
    showCombatNavbar() {
      return this.isAuthenticated && this.getCurrentView == 'dm_combat'
    },
    showCampaignNavbar() {
      return this.isAuthenticated && this.getCurrentView == 'campaigns'
    },
    showPageHeader() {
      if (this.isPublicAuthRoute) {
        return false
      }

      return (
        this.isAuthenticated &&
        this.getCurrentView != 'partial' &&
        this.getCurrentView != 'player_combat' &&
        this.getCurrentView != 'character_sheets' &&
        this.getCurrentView != 'character_adjustments_applied' &&
        this.getCurrentView != 'character_adjustments_optional' &&
        this.getCurrentView != 'character_adjustments'
      )
    },
    isPublicAuthRoute() {
      const routeName = this.$route?.name || ''
      return PUBLIC_AUTH_ROUTE_NAMES.includes(routeName)
    },
    showHeaderShell() {
      return (
        this.showRaceNavbar ||
        this.showCharacterNavbar ||
        this.showCombatNavbar ||
        this.showCampaignNavbar ||
        this.showPageHeader
      )
    },
    showNavigationShell() {
      return (
        this.showRaceNavbar ||
        this.showCharacterNavbar ||
        this.showCombatNavbar ||
        this.showCampaignNavbar
      )
    },
  },
  //-------------
  // on creation
  //-------------
  mounted() {
    console.log('HERE App.vue')
  },
}
</script>
